import { makeQuery } from 'shared/utilities';
import { IVacancyModel } from 'shared/models';

type RequestType = {
    id: number;
};

type ResponseType = {
    item: IVacancyModel[];
};

export const vacanciesGetQuery = async function (params: RequestType) {
    return await makeQuery<ResponseType>('/vacancies/get', { params });
}
